// extracted by mini-css-extract-plugin
module.exports = {"time":"TimeUnit_time__3_Xnl","timeLabel":"TimeUnit_timeLabel___DZDv"};